import React from 'react'
import Container from "react-bootstrap/Container"
import {snakeToPascal} from 'helpers/strings'
import renderComponents from "helpers/renderComponents"
import get from 'lodash.get'

function PublicApp(props) {
    const {data} = props
    const application = get(props.data ,'application')
    const RenderComponent = renderComponents(snakeToPascal(application.entity.component))    
  return (
    <Container fluid="fluid">
      <Container>
        <RenderComponent data={data} />
      </Container>
    </Container>
  );
}

export default PublicApp
